import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { AccordionCmp, AccordionProps } from "./Accordion"

interface AccordionWrapperBlokProps {
  blok: AccordionProps & blokType
  microdata: boolean
}

const Accordion: React.FC<AccordionWrapperBlokProps> = ({ blok, microdata}) => (
  <SbEditable content={blok}>
    <AccordionCmp
      items={blok.items}
      default_open={blok.default_open}
      microdata={microdata}   
    />
  </SbEditable>
)

export default Accordion 
